import { render, staticRenderFns } from "./Soja2024Eua.vue?vue&type=template&id=daa71a9c&lang=pug"
import script from "./Soja2024Eua.vue?vue&type=script&lang=js"
export * from "./Soja2024Eua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports